export const GET_STUDENT_COMPLETED_MAKES = (spaceId, studentId) =>
  `student/${studentId}/space/${spaceId}`;
export const ADD_STUDENT_TO_UNIT = (studentId) => `student/${studentId}/associate`;
